const Results = () => {
  return <div>results</div>;
};

export default Results;
